"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sportOptions = exports.getSportName = void 0;
var React = require("react");
var getSportName = function (value) {
    var sport = exports.sportOptions.find(function (option) { return option.value == value; });
    return sport === null || sport === void 0 ? void 0 : sport.text;
};
exports.getSportName = getSportName;
exports.sportOptions = [
    { value: "", text: "Select a sport" },
    { value: "1", text: "Basketball" },
    { value: "2", text: "Soccer" },
    { value: "4", text: "Softball" },
    { value: "5", text: "Baseball" },
    { value: "6", text: "Volleyball" },
    { value: "7", text: "Football" },
    { value: "8", text: "Cricket" },
    { value: "9", text: "Rugby" },
    { value: "10", text: "Lacrosse" },
    { value: "11", text: "Wiffleball" },
    { value: "13", text: "Bowling" },
    { value: "14", text: "Dodgeball" },
    { value: "15", text: "Field Hockey" },
    { value: "16", text: "Ice Hockey" },
    { value: "17", text: "Inline Hockey" },
    { value: "18", text: "Kickball" },
    { value: "19", text: "Paintball" },
    { value: "20", text: "Polo" },
    { value: "21", text: "Rowing" },
    { value: "22", text: "Ultimate" },
    { value: "23", text: "Water Polo" },
    { value: "24", text: "Other Sport" },
    { value: "25", text: "Dragon Boat" },
    { value: "26", text: "Australian Football" },
    { value: "27", text: "Badminton" },
    { value: "28", text: "Bandy" },
    { value: "29", text: "Bocce" },
    { value: "30", text: "Broomball" },
    { value: "31", text: "Cheerleading" },
    { value: "32", text: "Chess" },
    { value: "33", text: "Croquet" },
    { value: "34", text: "Curling" },
    { value: "35", text: "Cycling" },
    { value: "36", text: "Fencing" },
    { value: "37", text: "Foosball" },
    { value: "38", text: "Hurling" },
    { value: "39", text: "Indoor Soccer" },
    { value: "40", text: "Netball" },
    { value: "41", text: "Running" },
    { value: "42", text: "Swimming" },
    { value: "43", text: "Tennis" },
    { value: "44", text: "Floorball" },
    { value: "45", text: "Petanque" },
    { value: "46", text: "Golf" },
    { value: "47", text: "Sailing" },
    { value: "48", text: "Roller Derby" },
    { value: "49", text: "Wrestling" },
    { value: "50", text: "Ki-O-Rahi" },
    { value: "51", text: "Ringette" },
    { value: "52", text: "Non-Sport Group" },
    { value: "53", text: "Outrigger" },
    { value: "54", text: "Cow Tipping" },
    { value: "55", text: "Racquetball" },
    { value: "56", text: "Gymnastics-Men" },
    { value: "57", text: "Gymnastics-Women" },
    { value: "58", text: "Track And Field" },
    { value: "59", text: "Archery" },
    { value: "60", text: "Floor Hockey" },
    { value: "61", text: "Slo-pitch" },
    { value: "62", text: "Street Hockey" },
    { value: "63", text: "Pickleball" },
    { value: "64", text: "Wheelchair Basketball" },
    { value: "65", text: "Sled Hockey" },
    { value: "66", text: "Wheelchair Softball" },
    { value: "67", text: "Quad Rugby" },
    { value: "68", text: "Handcycling" },
    { value: "69", text: "Adaptive Sports" },
    { value: "70", text: "Cross Country" },
    { value: "71", text: "Cross Country Skiing" },
    { value: "72", text: "Alpine Skiing" },
    { value: "73", text: "Wheelchair Hockey" },
    { value: "74", text: "Wheelchair Volleyball" },
    { value: "75", text: "Wheelchair Lacrosse" },
    { value: "76", text: "Horseback Riding" },
    { value: "77", text: "Diving" },
    { value: "79", text: "Dance" },
    { value: "82", text: "Quidditch" },
    { value: "85", text: "Gymnastics-Coed" },
    { value: "88", text: "Musical Group" },
    { value: "90", text: "Flying" },
    { value: "93", text: "Darts" },
    { value: "99", text: "Pool and Billiards" },
    { value: "102", text: "Jump Rope" },
    { value: "105", text: "Camogie" },
    { value: "111", text: "Horseshoes" },
    { value: "114", text: "Squash" },
    { value: "116", text: "Synchronized Figure Skating" },
    { value: "119", text: "Figure Skating" },
    { value: "122", text: "Synchronized Swimming" },
    { value: "128", text: "Martial Arts" },
    { value: "134", text: "Mixed Martial Arts" },
    { value: "137", text: "Gaelic Football" },
    { value: "141", text: "Karaoke" },
    { value: "144", text: "Esports" },
    { value: "148", text: "Scouts" },
];
exports.default = (function (props) { return (React.createElement("div", { className: "SelectBox" },
    React.createElement("select", { className: "SelectBox-options " + (props.className || ""), onChange: props.onChange, value: props.value || undefined, id: props.id, ref: props.inputRef, name: props.name, disabled: props.disabled }, exports.sportOptions.map(function (o) { return (React.createElement("option", { key: o.value, value: o.value }, o.text)); })))); });
//# sourceMappingURL=sport-select.js.map